import React, { useState, useContext } from "react";
import { Field } from "formik";
import {
  FieldInputDollar,
  FieldButtonGroup,
  FieldDropSide,
  SearchableList,
  FieldInput,
  FieldTextarea,
  FieldInputNumber,
  FieldInputPercentage,
  DatePicker,
  MultiSelectDropdown,
  CsplTable as Table,
} from "../../../../../components";
import {
  yesNoOptions,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  usDateFormat,
  toMultiSelectValueById,
} from "../../../../../utils";
import { manageRkaasStore } from "../../../../../contexts";
import { useRequest } from "../../../../../abstracts";
import { getCompaniesList, getCompetingFunds } from "../../../../../services";
import { Dropdown } from "react-bootstrap";

const restrictionLabel = {
  1: "No of days with restriction",
  2: "No of weeks with restriction",
  3: "No of months with restriction",
  4: "No of years with restriction",
};

const columns = [
  {
    label: "Period",
    className: "column-period",
    columnName: "period",
  },
  {
    label: "Rate of return",
    isField: true,
    className: "column-rate-of-return",
    columnName: "rateOfReturn",
  },
];

const PerformanceResults = (props) => {
  const { state, dispatch } = useContext(manageRkaasStore);
  const {
    fields,
    values,
    setFieldValue,
    isEdit,
    isSave,
    handleChange,
    setTabGrey,
    investmentId,
  } = props;
  const { response: companies } = useRequest({
    method: getCompaniesList,
    payload: 1, //TenantId. HardCoding should be removed
    defaultResponse: [],
  });
  const typeOfEarnings = values[fields.typeOfEarnings];
  const dividends = values[fields.typeOfEarnings] === 3;
  const dividendType = values[fields.dividendType] === 1;
  const isAccural =
    values[fields.dividendType] === 2 || values[fields.dividendType] === 3;
  const dblList = (min, max) => {
    const listOptions = [];
    obj = {};
    for (var i = min; i <= max; i++) {
      var obj = {};
      obj["id"] = i;
      obj["value"] = i;
      obj["label"] = i;
      listOptions.push(obj);
    }
    return listOptions;
  };
  const { response: competingFundsList } = useRequest({
    method: getCompetingFunds,
    payload: investmentId != undefined ? investmentId : 0, //TenantId. HardCoding should be removed
    defaultResponse: [],
  });

  return (
    <>
      <div>
        <label
          for={fields.inceptionDate}
          style={{
            fontSize: "0.75rem",
            whiteSpace: "nowrap",
          }}
        >
          Inception Date
        </label>
        <Dropdown
          as="button"
          className={`form-control dropSide disabled`}
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            width: "200px",
            fontSize: "0.75rem",
          }}
          type="button"
          disabled={true}
          name={fields.inceptionDate}
        >
          <div className="dropSide-custom-select">
            {usDateFormat(values[fields.inceptionDate])}
          </div>
        </Dropdown>
        <Field
          size="smd"
          name={fields.asOfDate}
          placeholder="To"
          value={usDateFormat(values[fields.asOfDate])}
          direction="right"
          isDatePicker
          label="As of date"
          onClear={() => setFieldValue(fields.asOfDate, "")}
          popupContent={
            <DatePicker
              onDayClick={(value) => {
                setTabGrey(1);
                setFieldValue(fields.asOfDate, value);
              }}
              value={usDateFormat(values[fields.asOfDate])}
            />
          }
          disabled={isEdit && !isSave}
          component={FieldDropSide}
        />
        <div className="performance-results">
          <Table>
            <Table.Thead>
              <Table.Tr>
                {columns.map((item, index) => {
                  return (
                    <Table.Th className={item.className}>{item.label}</Table.Th>
                  );
                })}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              <Table.Tr>
                <Table.Td className="column-period">Current</Table.Td>
                <Table.Td className="column-rate-of-return">
                  <Field
                    name={fields.current}
                    size="sm"
                    isAllowNegative
                    type="number"
                    autoComplete="off"
                    min={-100}
                    max={100}
                    showDecimal
                    value={values[fields.current]}
                    onChange={(e) => {
                      setTabGrey(1);
                      handleChange(e);
                    }}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                  />
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td className="column-period">YTD</Table.Td>
                <Table.Td className="column-rate-of-return">
                  <Field
                    name={fields.ytd}
                    size="sm"
                    isAllowNegative
                    showDecimal
                    type="number"
                    autoComplete="off"
                    min={-100}
                    max={100}
                    value={values[fields.ytd]}
                    onChange={(e) => {
                      setTabGrey(1);
                      handleChange(e);
                    }}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                  />
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td className="column-period">From inception</Table.Td>
                <Table.Td className="column-rate-of-return">
                  <Field
                    name={fields.fromInception}
                    size="sm"
                    isAllowNegative
                    showDecimal
                    type="number"
                    autoComplete="off"
                    min={-100}
                    max={100}
                    value={values[fields.fromInception]}
                    onChange={(e) => {
                      setTabGrey(1);
                      handleChange(e);
                    }}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                  />
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td className="column-period">3 months</Table.Td>
                <Table.Td className="column-rate-of-return">
                  <Field
                    name={fields.threeMonths}
                    size="sm"
                    isAllowNegative
                    showDecimal
                    type="number"
                    autoComplete="off"
                    min={-100}
                    max={100}
                    value={values[fields.threeMonths]}
                    onChange={(e) => {
                      setTabGrey(1);
                      handleChange(e);
                    }}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                  />
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td className="column-period">1 year</Table.Td>
                <Table.Td className="column-rate-of-return">
                  <Field
                    name={fields.oneYear}
                    size="sm"
                    isAllowNegative
                    showDecimal
                    type="number"
                    autoComplete="off"
                    min={-100}
                    max={100}
                    value={values[fields.oneYear]}
                    onChange={(e) => {
                      setTabGrey(1);
                      handleChange(e);
                    }}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                  />
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td className="column-period">3 years</Table.Td>
                <Table.Td className="column-rate-of-return">
                  <Field
                    name={fields.threeYears}
                    size="sm"
                    isAllowNegative
                    showDecimal
                    type="number"
                    autoComplete="off"
                    min={-100}
                    max={100}
                    value={values[fields.threeYears]}
                    onChange={(e) => {
                      setTabGrey(1);
                      handleChange(e);
                    }}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                  />
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td className="column-period">5 years</Table.Td>
                <Table.Td className="column-rate-of-return">
                  <Field
                    name={fields.fiveYears}
                    size="sm"
                    isAllowNegative
                    showDecimal
                    type="number"
                    autoComplete="off"
                    min={-100}
                    max={100}
                    value={values[fields.fiveYears]}
                    onChange={(e) => {
                      setTabGrey(1);
                      handleChange(e);
                    }}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                  />
                </Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td className="column-period">10 years</Table.Td>
                <Table.Td className="column-rate-of-return">
                  <Field
                    name={fields.tenYears}
                    size="sm"
                    isAllowNegative
                    showDecimal
                    type="number"
                    autoComplete="off"
                    min={-100}
                    max={100}
                    value={values[fields.tenYears]}
                    onChange={(e) => {
                      setTabGrey(1);
                      handleChange(e);
                    }}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                  />
                </Table.Td>
              </Table.Tr>
            </Table.Tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default PerformanceResults;
